var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIntreruptorCuPlutitorContactNormalDeschis(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 92,
    viewBox: "0 0 76 92",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 47L28 47",
    stroke: "black",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29 47H34",
    stroke: "black",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 47C19.5 47.7849 18.8174 48.7792 17.0594 49.6368C15.3685 50.4616 12.9622 51 10.25 51C7.53775 51 5.13153 50.4616 3.44058 49.6368C1.68256 48.7792 1 47.7849 1 47C1 46.2151 1.68256 45.2208 3.44058 44.3632C5.13153 43.5384 7.53775 43 10.25 43C12.9622 43 15.3685 43.5384 17.0594 44.3632C18.8174 45.2208 19.5 46.2151 19.5 47Z",
    stroke: "black",
    strokeWidth: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10 42V27",
    stroke: "black",
    strokeWidth: 2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M36 33.9023L36 0.000101737",
    stroke: "black",
    strokeWidth: 2
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M36 92L36 49",
    stroke: "black",
    strokeWidth: 2
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M20 29L36.6028 49.7332",
    stroke: "black",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntreruptorCuPlutitorContactNormalDeschis);
export default __webpack_public_path__ + "static/media/intreruptor_cu_plutitor_contact_normal_deschis.4b1f1cce40c30b3d07d3ee3ab40ccc2c.svg";
export { ForwardRef as ReactComponent };